import { MAX_FILE_SIZE } from '../../../../config/consts/commons';

export const IMAGE_PROCESSING_ERRORS = {
  MAX_FILE_SIZE: 'MAX_FILE_SIZE_ERROR',
  COMPRESS_FAILED: 'COMPRESS_IMAGE_ERROR',
  MEMORY_ERROR: 'MEMORY_ERROR',
  CORRUPT_ERROR: 'CORRUPT_ERROR',
  UNSUPPORTED_ERROR: 'UNSUPPORTED_ERROR',
};

export const validateImageSize = async ({ file }) => {
  try {
    if (file.size > MAX_FILE_SIZE) {
      return {
        file: null,
        success: false,
        message: IMAGE_PROCESSING_ERRORS.MAX_FILE_SIZE,
      };
    }

    return { file, success: true, message: 'COMPRESS_IMAGE_SUCCESS' };
  } catch (error) {
    console.error('COMPRESS_IMAGE_ERROR_LOG', error);
    return {
      file: null,
      success: false,
      message: IMAGE_PROCESSING_ERRORS.COMPRESS_FAILED,
    };
  }
};
